import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider, useAuth } from './contexts/AuthContext'
import { AccountProvider } from './contexts/AccountContext'
import { PromptProvider } from './contexts/PromptContext'
import { CreditsProvider } from './contexts/CreditsContext'
import { ProtectedRoute } from './components/ProtectedRoute'
import { ScrollToTop } from './components/ScrollToTop'
import { LandingPage } from './components/LandingPage'
import { Login } from './components/Login'
import { Signup } from './components/Signup'
import { ConfirmEmail } from './components/ConfirmEmail'
import { ForgotPassword } from './components/ForgotPassword'
import { Dashboard } from './components/Dashboard'
import { HelpSupport } from './components/HelpSupport'
import { Pricing } from './components/Pricing'
import { PaymentSuccess } from './components/PaymentSuccess'
import { PaymentCancel } from './components/PaymentCancel'
import './App.css'

// Component to handle root route - redirect to dashboard if authenticated, show landing page otherwise
const RootRoute: React.FC = () => {
  const { isAuthenticated, loading } = useAuth()
  
  if (loading) {
    return <div className="loading">Loading...</div>
  }
  
  return isAuthenticated ? <Navigate to="/dashboard" replace /> : <LandingPage />
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <AuthProvider>
        <AccountProvider>
          <CreditsProvider>
            <PromptProvider>
              <Routes>
                <Route path="/" element={<RootRoute />} />
                <Route path="/login" element={<Login />} />
                <Route path="/signup" element={<Signup />} />
                <Route path="/confirm-email" element={<ConfirmEmail />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                
                <Route
                  path="/dashboard"
                  element={
                    <ProtectedRoute>
                      <Dashboard />
                    </ProtectedRoute>
                  }
                />
                
                {/* Help page - accessible to all users */}
                <Route path="/help" element={<HelpSupport />} />
                
                {/* Pricing page - accessible to all users */}
                <Route path="/pricing" element={<Pricing />} />
                
                {/* Payment result pages */}
                <Route path="/payment/success" element={<PaymentSuccess />} />
                <Route path="/payment/cancel" element={<PaymentCancel />} />
              </Routes>
            </PromptProvider>
          </CreditsProvider>
        </AccountProvider>
      </AuthProvider>
    </Router>
  )
}

export default App
